// Taken from variables.scss because graph requires colors in string. If only we could the styles instead...
export const colorGreen = 'rgb(107, 181, 54)';
export const colorGreenLight = '#62ff00';
export const colorOrange = 'rgb(238, 166, 0)';
export const colorRed = 'rgb(254, 6, 6)';
export const chartGrayDark = '#545b61';
export const chartGrayLight = '#a9b0bc';
export const colorGrey = '#dad8d8';
export const colorYellow = '#ffff33';
export const colorOrgBlue = '#28313C';
export const colorMetalGrey = '#ededed';
export const colorPrimaryLight10Presto = '#a0d97b';
export const colorPrimaryLight20Presto = '#c8e2b8';